import {
  DebouncedNumberInput,
  DebouncedTextInput,
  GroupTitle,
  Toolbar,
  useFieldLabel,
} from "ra-friendsofbabba";
import {
  SimpleForm,
  minLength,
  minValue,
  required,
  useQueryWithStore,
} from "react-admin";

import ForeignOfficeInput from "./inputs/ForeignOfficeInput";
import InputWithTopHelpWrapper from "./inputs/InputWithTopHelpWrapper";
import MonthInput from "./inputs/MonthInput";
import React from "react";
import classNames from "classnames";
import { get } from "lodash";
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  input: {
    width: 190,
    marginRight: theme.spacing(1),
    display: "inline-block",
    float: "left",
    marginBottom: theme.spacing(2),
  },
  inputMonth: {},
}));

const Form = ({ ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const classes = useStyles();
  const { data } = useQueryWithStore({
    type: "get",
    resource: "research-project-activities/config",
    payload: {
      query: {
        id: props.record.id,
        research_project_id: props.record.research_project_id,
      },
    },
  });
  const companyTypeId = get(data, "data.company_type_id", 0);
  const usablePublicMonths = get(data, "data.usable_public_months", 0);
  const usableForeignMonths = get(data, "data.usable_foreign_months", 0);
  const usablePrivateMonths = get(data, "data.usable_private_months", 0);
  const translate = useTranslate();
  const validatePublicMonths = () => (value) => {
    if (value > usablePublicMonths) {
      return translate("ra.validation.max.public", {
        max: usablePublicMonths,
      });
    }
  };
  const validateForeignMonths = () => (value) => {
    if (value > usableForeignMonths) {
      return translate("ra.validation.max.foreign", {
        max: usableForeignMonths,
      });
    }
  };
  const validatePrivateMonths = () => (value) => {
    if (value > usablePrivateMonths) {
      return translate("ra.validation.max.private", {
        max: usablePrivateMonths,
      });
    }
  };

  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={2}
          backReference="research-projects"
          backReferenceTarget="research_project_id"
        />
      }
      initialValues={{
        public_months: 0,
        private_months: 0,
        foreign_months: 0,
        from_month: parseInt(get(data, "data.max_month", 0), 10) + 1,
      }}
    >
      <MonthInput
        source="from_month"
        className={classes.input}
        helperText="resources.research-project-activities.fields.from_month.help"
        fullWidth
      />
      <MonthInput source="to_month" className={classes.input} fullWidth />
      <DebouncedTextInput
        source="title"
        maxLength={250}
        validate={[required()]}
        fullWidth
      />
      <DebouncedTextInput
        source="description"
        minLength={500}
        maxLength={2000}
        validate={[required(), minLength(500)]}
        multiline
        fullWidth
      />
      <GroupTitle
        title={translate(
          "resources.research-project-activities.sections.perc.title"
        )}
        subTitle={translate(
          "resources.research-project-activities.sections.perc.help"
        )}
      />
      <InputWithTopHelpWrapper
        helperText={fieldLabel(`months.public.${companyTypeId}.help`)}
        label={fieldLabel("months")}
        source="public_months"
        fullWidth
        validate={[required(), validatePublicMonths(), minValue(0)]}
        className={classNames(classes.input, classes.inputMonth)}
        InputProps={{ inputProps: { min: 0 } }}
      >
        <DebouncedNumberInput />
      </InputWithTopHelpWrapper>
      <InputWithTopHelpWrapper
        helperText={fieldLabel(`months.private.help`)}
        label={fieldLabel("months")}
        source="private_months"
        fullWidth
        validate={[required(), validatePrivateMonths(), minValue(0)]}
        className={classNames(classes.input, classes.inputMonth)}
        InputProps={{ inputProps: { min: 0 } }}
      >
        <DebouncedNumberInput />
      </InputWithTopHelpWrapper>
      <InputWithTopHelpWrapper
        label={fieldLabel("months")}
        helperText={fieldLabel("months.foreign.help")}
        source="foreign_months"
        fullWidth
        validate={[required(), validateForeignMonths(), minValue(0)]}
        className={classNames(classes.input, classes.inputMonth)}
        InputProps={{ inputProps: { min: 0 } }}
      >
        <DebouncedNumberInput />
      </InputWithTopHelpWrapper>
      <InputWithTopHelpWrapper source="foreign_office">
        <ForeignOfficeInput />
      </InputWithTopHelpWrapper>
      <DebouncedTextInput
        source="output"
        validate={[required(), minLength(500)]}
        minLength={500}
        maxLength={2000}
        fullWidth
        multiline
      />
    </SimpleForm>
  );
};
export default Form;
